export default __webpack_public_path__ + "static/media/laptop.59574435.jpg";